import { getRotationInfo } from '@/app/utils/helpers';
import HELPER from '@/app/utils/HELPER';
import { AtomTargetHandler } from './AtomTargetHandler';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';

/**
 * P Image Badge Setting Handler
 */
export class ShBadgeRotateText extends AtomTargetHandler {
  /**
   * read
   * @param options options
   * @param options.screenType screenType
   * @param options.$activePanel $activePanel
   */
  read(options: { screenType: any; $activePanel: JQuery; $atom: JQuery; atomModel: AtomModel }) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const $self = this.getAtomTarget('read', this);

    // transform (Rotate Text)
    const $badgeAnchor = $self.siblings('.gf_product-badge-anchor');
    const rotationTextInfo: any = getRotationInfo($badgeAnchor.find('span'));
    const value: any = rotationTextInfo && rotationTextInfo.deg ? rotationTextInfo.deg : 0;
    options.$activePanel.find('#badgeRotateText').val(value).attr('value', value).trigger('value-change');
  }

  /**
   * write
   * @param value value
   * @param options options
   * @param options.screenType screenType
   * @returns style
   */
  write(
    value: string,
    options: {
      screenType: any;
      $atom: JQuery;
      $activePanel: JQuery;
      atomModel: AtomModel;
    },
  ) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const targetSelector = this.setting.targetSelector as string;
    const $self = this.getAtomTarget('write', this);
    let style = this.getAtomModel().style;
    const refreshType = this.setting.refreshType ? this.setting.refreshType : 'css';
    if (!targetSelector) {
      alert(`Thiếu targetSelector: ${this.setting.name}`);
    } else {
      if (this.setting.options?.length) {
        for (let i = 0; i < this.setting.options.length; i++) {
          const option = this.setting.options[i];
          if (option.key == value) {
            value = option.value;
          }
        }
      }
      const degVal: any = options.$activePanel.find('#badgeRotateText').val();
      const rotateDeg = degVal ? parseInt(degVal) : 0;
      const deOptionsTextRotate = [
        {
          key: 'transform',
          value: `rotate(${rotateDeg}deg)`,
        },
      ];
      const targetSelector = this.setting.targetSelector as string;
      style = HELPER.designOptions2Style($self, options.screenType, style, deOptionsTextRotate, targetSelector);
    }
    screenTop;
    return {
      refreshType: refreshType,
      style: style,
    };
  }
  /**
   * getAtomModel
   * @returns atomModel :jQuery
   */
  getAtomModel() {
    return this.atomModel;
  }
}
